import axios from 'axios';

// Sobrescreva com VUE_APP_API_URL (arquivo .env) para apontar para outra
// instancia sem editar este arquivo.
const urlBase = process.env.VUE_APP_API_URL || 'https://planoscomerciais.alfameta.app';

// O site consome o contrato legado em /api. As rotas novas — hoje so as de
// logo — vivem em /api/v1 e aceitam o mesmo token do login.
const api = axios.create({ baseURL: `${urlBase}/api` });
const apiV1 = axios.create({ baseURL: `${urlBase}/api/v1` });

function anexarToken(config) {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}

api.interceptors.request.use(anexarToken);
apiV1.interceptors.request.use(anexarToken);

export { apiV1 };
export default api;
